export enum EditorElement {
   Menubar,
   Toolbar,
   Footer,
   SearchAndReplaceDialog,
   RightClickMenu,
   TableBubbleMenu,
   ListBubbleMenu,
}